/*
Ashraf 01/20/2023 2698088984 added form for view candidates
Ashraf 01/27/2023 2698088984 disabled fields for closed batches
Prakash 9/05/2023 2698088984  fixed alignment issue in tab veiw andadd theming classname

*/
import {
  TextField,
  Grid,
  FormHelperText,
  InputAdornment,
} from '@material-ui/core';
import React, {useContext} from 'react';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import {KeyboardDatePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {SsnMaskCustom} from '../../../../../util/SsnMaskFormat';
import {Currency, PhoneMaskCustom} from '../../../../../util/Currency';
import {NumberFormatter} from '../../../../../components/UserDefinedForm/AppTextInputComponents';
import moment from 'moment';
import {useHistory} from 'react-router';

const GetAccessMethodFields = ({
  accessMethodFields,
  values,
  setFieldValue,
  setShowRuleGroupSearch,
  reportDialogData,
  fieldCodeValue,
  additionalInfoData,
  renderedFrom,
  formProps,
  fieldSubmitted,
  setSubmitted,
  addTask,
}) => {
  const {touched, errors, handleChange, handleBlur} = formProps;
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const history = useHistory();
  const ClosedTab = history?.location?.state?.closedBatch === 'Yes';

  const getField = (field, key) => {
    switch (field?.fieldType?.toLowerCase()) {
    case 'text':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            placeholder={`Enter ${field.fieldLabel}`}
            className={`${classes.labelName}`}
            label={field?.fieldLabel}
            // InputLabelProps={{
            //     shrink: true,
            // }}
            disabled={ClosedTab}
            name={field.fieldName}
            value={values[field.fieldName] || ''}
            onChange={(e) => {
              setFieldValue(field.fieldName, e.target.value);
            }}
            // InputProps={{
            //     endAdornment: (
            //         <>
            //             {values[field?.paramName]?.length > 0 ? (
            //                 <IconButton
            //                     onClick={() => {
            //                         setFieldValue(field?.paramName, "");
            //                     }}
            //                     style={{ padding: "0px", marginTop: "1rem" }}
            //                 >
            //                     <Clear />
            //                 </IconButton>
            //             ) : (
            //                 <Button
            //                     variant="contained"
            //                     className={` ${classes.filterGroupButton}`}
            //                     style={{
            //                         padding: "0px",
            //                         fontSize: "0.7rem",
            //                         letterSpacing: "1px",
            //                         fontWeight: "bold",
            //                         marginBottom: "3px",
            //                     }}
            //                     disabled={isCurrentFieldDisabled(field.paramName)}
            //                     onClick={() => {
            //                         dispatch(
            //                             handleSearchRuleGroupFieldData({
            //                                 status: true,
            //                                 fieldName: field.paramName,
            //                                 setFieldValue: setFieldValue,
            //                                 setShowSearch: setShowRuleGroupSearch,
            //                             })
            //                         );
            //                         setShowRuleGroupSearch(true);
            //                     }}
            //                     size="small"
            //                 >
            //                     Search
            //                 </Button>
            //             )}
            //         </>
            //     ),
            // }}
            fullWidth
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'amount':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            className={`${classes.labelName}`}
            placeholder={`Enter ${field?.fieldLabel}`}
            label={field?.fieldLabel}
            // InputLabelProps={{
            //     shrink: true,
            // }}
            disabled={ClosedTab}
            InputProps={{
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
              inputComponent: Currency,
            }}
            name={field?.fieldName}
            value={values[field?.fieldName]}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            touched={touched[field?.fieldName]}
            error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'number':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            className={`${classes.labelName}`}
            placeholder={`Enter ${field?.fieldLabel}`}
            label={field?.fieldLabel}
            // InputLabelProps={{
            //     shrink: true,
            // }}
            disabled={ClosedTab}
            InputProps={{
              inputComponent: NumberFormatter,
            }}
            name={field?.fieldName}
            value={values[field?.fieldName]}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            touched={touched[field?.fieldName]}
            error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'ssn':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            className={`${classes.labelName}`}
            placeholder={`Enter ${field?.fieldLabel}`}
            label={field?.fieldLabel}
            //   InputLabelProps={{
            //     shrink: true,
            //   }}
            disabled={ClosedTab}
            InputProps={{
              inputComponent: SsnMaskCustom,
            }}
            name={field?.fieldName}
            value={values[field?.fieldName]}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            touched={touched[field?.fieldName]}
            error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'phone':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            className={`${classes.labelName}`}
            placeholder={`Enter ${field?.fieldLabel}`}
            label={field?.fieldLabel}
            //   InputLabelProps={{
            //     shrink: true,
            //   }}
            disabled={ClosedTab}
            InputProps={{
              inputComponent: PhoneMaskCustom,
            }}
            name={field?.fieldName}
            value={values[field?.fieldName]}
            onChange={handleChange}
            onBlur={handleBlur}
            fullWidth
            touched={touched[field?.fieldName]}
            error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'date':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Grid container>
              <KeyboardDatePicker
                // onChange={(val) => setFieldValue("minDate", val)}
                name={field?.fieldName}
                autoOk
                className={`${classes.labelName}`}
                margin="dense"
                helperText={''}
                inputVariant="outlined"
                format="MM/dd/yyyy"
                placeholder="MM/DD/YYYY"
                fullWidth
                defaultValue={null}
                //   InputLabelProps={{
                //     shrink: true,
                //   }}
                disabled={ClosedTab}
                label={field?.fieldLabel}
                value={values[field?.fieldName]}
                onChange={(val) => {
                  setFieldValue(field?.fieldName, val !== null ? moment(val).format('MM/DD/YYYY') : null);
                }}
                onBlur={handleBlur}
                touched={touched[field?.fieldName]}
                error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
              />
            </Grid>
          </MuiPickersUtilsProvider>
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'dropdown':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <GuiAutoComplete
            classes={{
              option: classes.option,
            }}
            name={field?.fieldName}
            id={field?.fieldName}
            size="small"
            value={values[field?.fieldName]}
            className="select-gender"
            options={[]}
            autoHighlight
            disabled={ClosedTab}
            getOptionDisabled={(option) => option?.valueCode === ''}
            getOptionLabel={(option) => {
              return option && option?.value ?
                option?.valueCode === null ?
                  option?.value :
                  option?.valueCode + ' - ' + option?.value :
                '';
            }}
            onChange={(e, value) => {
              setFieldValue(field?.fieldName, value);
            }}
            placeholder={`Select ${field?.fieldLabel}`}
            renderInput={(params) => (
              <div className="select-field">
                <GuiTextField
                  className={`${classes.labelName}`}
                  {...params}
                  variant="outlined"
                  margin="dense"
                  name={field?.fieldName}
                  label={field?.fieldLabel}
                  placeholder={`Select ${field?.fieldLabel}`}
                />
              </div>
            )}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    case 'email':
      return (
        <div
          key={key}
          className={`col-md-4 col-lg-3  form-group `}
        >
          <TextField
            margin="dense"
            variant="outlined"
            placeholder={`Enter ${field.fieldLabel}`}
            className={`${classes.labelName}`}
            label={field?.fieldLabel}
            type="email"
            //   InputLabelProps={{
            //     shrink: true,
            //   }}
            disabled={ClosedTab}
            name={field.fieldName}
            value={values[field.fieldName] || ''}
            onChange={(e) => {
              setFieldValue(field.fieldName, e.target.value);
            }}
            fullWidth
            touched={touched[field?.fieldName]}
            error={Boolean(touched[field?.fieldName] && errors[field?.fieldName])}
          />
          <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
        </div>
      );
    default: return (
      <div
        key={key}
        className={`col-md-4 col-lg-3  form-group `}
      >
        <TextField
          margin="dense"
          variant="outlined"
          placeholder={`Enter ${field.fieldLabel}`}
          className={`${classes.labelName}`}
          label={field?.fieldLabel}
          // InputLabelProps={{
          //   shrink: true,
          // }}
          disabled={ClosedTab}
          name={field.fieldName}
          value={values[field.fieldName] || ''}
          onChange={(e) => {
            setFieldValue(field.fieldName, e.target.value);
          }}
          fullWidth
        />
        <FormHelperText>{touched[field?.fieldName] && errors[field?.fieldName]}</FormHelperText>
      </div>
    );
    }
  };
  return (
    <>
      {accessMethodFields?.length > 0 &&
                accessMethodFields.map((field, key) => {
                  return getField(field, key);
                })}
    </>
  );
};

export default GetAccessMethodFields;
